import { faLocationPin } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import PhoenixLoader from 'components/common/PhoenixLoader';
import ToastMessage from 'components/common/ToastMessage';
import Footer from 'components/footers/Footer';
import { changeLanguage } from 'i18n';
import { PropsWithChildren, startTransition, Suspense } from 'react';
import { Container, Nav, Navbar, NavbarBrand } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const PublicLayout = ({ children }: PropsWithChildren) => {
  const { t, i18n } = useTranslation();

  const handleChangeLanguage = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const language = event.target.value;
    startTransition(() => {
      changeLanguage(language);
    });
  };

  return (
    <Container fluid className="px-0">
      <Suspense fallback={<PhoenixLoader />}>
        <Navbar
          className="navbar-top fixed-top navbar-slim d-flex align-items-center justify-content-between"
          expand="lg"
          variant=""
          data-navbar-appearance="dark"
        >
          <NavbarBrand />
          <div className="d-flex align-items-center justify-content-end">
            <Nav.Item className="me-1 me-3">
              <select
                onChange={handleChangeLanguage}
                defaultValue={i18n.language}
                className="border-0"
              >
                <option value="en">EN</option>
                <option value="km">KH</option>
              </select>
            </Nav.Item>

            <div className="me-4">
              <Button
                href="/track-my-case"
                variant="subtle-warning"
                className="w-100 rounded-pill"
              >
                <FontAwesomeIcon icon={faLocationPin} className="me-2" />
                {t('track_my_case')}
              </Button>
            </div>
          </div>
        </Navbar>

        <div className="content">
          {children}
          <Footer className="position-absolute" />
        </div>
      </Suspense>

      <ToastMessage />
    </Container>
  );
};

export default PublicLayout;
